import request from "@/utils/request";

export function getReportApi(params) {
  return request({
    url: "?c=mes&a=report&do=get",
    method: "get",
    params
  });
}
